import React from "react";

const RightArrowIcon = ({ size = 8, color = "none", className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 8 8"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.84523 3.61335L4.70987 0.133787C4.60826 0.0443538 4.47561 -0.00345453 4.33919 0.000194517C4.20278 0.00384357 4.07297 0.0586728 3.97648 0.153405C3.87998 0.248137 3.82413 0.375568 3.82041 0.50949C3.8167 0.643411 3.86539 0.77364 3.95649 0.873389L6.76444 3.98992L3.95649 7.10644C3.86539 7.20619 3.8167 7.33642 3.82041 7.47034C3.82413 7.60426 3.87998 7.7317 3.97648 7.82643C4.07297 7.92116 4.20278 7.97599 4.33919 7.97964C4.47561 7.98329 4.60826 7.93548 4.70987 7.84605L7.84523 4.36648C7.95119 4.26246 8.00205 4.12619 7.99993 3.98992C8.00107 3.92019 7.98796 3.85094 7.96139 3.78627C7.93482 3.72159 7.89532 3.6628 7.84523 3.61335ZM0.155703 7.84709C0.363385 8.05097 0.701397 8.05097 0.909079 7.84709L4.04444 4.36752C4.1504 4.2635 4.20126 4.12723 4.19914 3.99096C4.20061 3.92118 4.18766 3.85185 4.16107 3.78712C4.13448 3.7224 4.0948 3.66364 4.04444 3.61439L0.910139 0.133787C0.808531 0.0443538 0.675877 -0.00345453 0.539462 0.000194517C0.403046 0.00384357 0.273241 0.0586728 0.176745 0.153405C0.080249 0.248137 0.0243992 0.375568 0.0206822 0.50949C0.0169652 0.643411 0.0656639 0.77364 0.156762 0.873389L2.96471 3.98992L0.156762 7.10644C0.0565874 7.20453 0.000199236 7.33766 5.26952e-07 7.47655C-0.000198182 7.61544 0.055809 7.74873 0.155703 7.84709Z"
      fill="#BEBEBE"
    />
  </svg>
);

export default RightArrowIcon;
